/*
 *
 * Header constants
 *
 */

enum ActionTypes {
  SWITCH_TAB_REQUEST = 'app/Header/SWITCH_TAB_REQUEST',
  TAB_DISPLAYED_CHANGED = 'app/Header/TAB_DISPLAYED_CHANGED',
}

export default ActionTypes;
